/*
* Environment specific variables
*/
export const REACT_APP_NETWORK_ID = Number(process.env.REACT_APP_NETWORK_ID) || 0;

/*
* API URLs
*/
export const XRPSCAN_API_URL = process.env.REACT_APP_XRPSCAN_API_URL || 'https://api.xrpscan.com/api/v1';
export const XRPSCAN_WSS_URL = process.env.REACT_APP_XRPSCAN_WSS_URL || 'https://ws.xrpscan.com';
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-X9R71TB1SV';
export const REACT_APP_SERVER_VERSIONS_LIMIT = process.env.REACT_APP_SERVER_VERSIONS_LIMIT || 4;
export const REACT_APP_AVATAR_CACHE_KEY = process.env.REACT_APP_AVATAR_CACHE_KEY || 1;
export const REACT_APP_AVATAR_HOST = process.env.REACT_APP_AVATAR_HOST || "https://unavatar.io";
export const XRPL_SERVER_VERSIONS = ['3.2.0'];
